import React from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Paragraph,
    Flex,
} from '@zillow/constellation';

import { PAYMENT_DESCRIPTION_TO_TYPE } from 'app/shared/constants/PaymentConstants';

import numberUtils from 'app/shared/utils/numberUtils';
import { StyledEllipsisParagraph } from 'app/shared/StyledComponents/StyledComponents';

import InteractiveCard from 'app/shared/components/InteractiveCard';
import { StyledHR } from './StyledComponents';
import PaymentTracker from './PaymentTracker';

const propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    paymentTracker: PropTypes.shape({
        statusText: PropTypes.string.isRequired,
        statusType: PropTypes.string.isRequired,
        trackerStates: PropTypes.arrayOf(PropTypes.shape({
            icon: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
            styling: PropTypes.string.isRequired,
        })),
        ctaButtons: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            styling: PropTypes.string.isRequired,
        })),
        disclaimer: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string.isRequired,
            styling: PropTypes.string,
            url: PropTypes.string,
        })),
    }).isRequired,
};

const PaymentsCard = ({
    title,
    amount,
    description,
    firstName,
    lastName,
    paymentTracker,
}) => (
    <InteractiveCard isDisabled={true} data-test="confirmation-payments-message-card">
        <Flex display="flex" justifyContent="space-between" alignItems="center">
            <Paragraph fontType="bodyHeading">{title}</Paragraph>
            <Paragraph fontType="h4">{numberUtils.asCurrency(amount / 100)}</Paragraph>
        </Flex>
        <Paragraph fontType="bodySmall" paddingTop="xs">{description}</Paragraph>
        <StyledEllipsisParagraph fontType="bodySmall">
            {firstName}
            {' '}
            {lastName}
        </StyledEllipsisParagraph>
        <StyledHR color="gray300" />
        {
            (paymentTracker) && (
                <PaymentTracker
                    paymentType={PAYMENT_DESCRIPTION_TO_TYPE[description.toLowerCase()]}
                    {...paymentTracker}
                />
            )
        }
    </InteractiveCard>
);

PaymentsCard.propTypes = propTypes;

export default PaymentsCard;
